import { render } from "./AssignmentCard.vue?vue&type=template&id=2bb35bb6&scoped=true"
import script from "./AssignmentCard.vue?vue&type=script&lang=js"
export * from "./AssignmentCard.vue?vue&type=script&lang=js"

import "./AssignmentCard.vue?vue&type=style&index=0&id=2bb35bb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb35bb6"]])

export default __exports__